import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

export default function Testimonials() {

  const testimonials = [
    {
      id: 1,
      name: "Neha Mehta",
      message:
        "Sera Water provided customized wastewater treatment solutions for our pharmaceutical facility in Gujarat. Their ETP and STP equipment helped us improve efficiency while meeting strict environmental compliance.",
    },
    {
      id: 2,
      name: "Amit Shah",
      message:
        "We installed twin lobe blowers and dosing pumps from Sera Water for our STP plant. The performance of the water treatment equipment has been excellent, ensuring consistent aeration and smooth plant operation.",
    },
    {
      id: 3,
      name: "Rajesh Patel",
      message:
        "Sera Water provided customized wastewater treatment solutions for our pharmaceutical facility in Gujarat. Their ETP and STP equipment helped us improve efficiency while meeting strict environmental compliance.",
    },
  ];

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-6">

        {/* SECTION HEADING */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary">
            What Our Clients Say
          </h2>
          <p className="mt-4 text-gray-600 font-body max-w-2xl mx-auto">
            Hear from our clients who trust Sera Water for reliable water and
            wastewater treatment solutions across industries.
          </p>
        </div>

        {/* TESTIMONIALS SLIDER */}
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop
          spaceBetween={30}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="relative bg-gray-50 rounded-xl p-6 shadow-sm hover:shadow-lg transition h-full">

                <FontAwesomeIcon
                  icon={faQuoteLeft}
                  className="text-primary/20 text-8xl absolute -bottom-5 right-3"
                />

                {/* REVIEW */}
                <p className="text-gray-700 font-body italic leading-relaxed min-h-[140px]">
                  “{item.message}”
                </p>

                {/* CLIENT INFO */}
                <div className="flex items-center gap-4 mt-6">
                  <div>
                    <h4 className="text-primary font-heading font-semibold">
                      {item.name}
                    </h4>
                  </div>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
}